import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

export default task(async function() {
  const api = inject(ApiService)
  return await api.request({ url: '/api/service_types' })
}, {
  defaultValue: []
})



// WEBPACK FOOTER //
// ./src/tasks/getServices.js